import { app } from '../../../../app';
import { Controller } from './dropbox-provisioning.controller';

app.component('companyManageApplicationDropboxProvisioning', {
    bindings: {
        application: '<',
        dropboxConfigurationDTO: '<',
    },
    controller: Controller,
    templateUrl: require('./dropbox-provisioning.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-provisioning.component.js